import {
  facebook,
  instagram,
  linkedin,
  people01,
  people02,
  people03,
  people04,
  send,
  shield,
  sponsor,
  star,
  twitter,
} from "../assets";

export const navLinks = [
  {
    id: "",
    title: "Home",
  },
  {
    id: "how-it-works",
    title: "How It Works",
  },
  {
    id: "blog",
    title: "Blog",
  },
  {
    id: "help-center",
    title: "Help Center",
  },
  {
    id: "partners",
    title: "Partners",
  },
];

export const innovations = [
  {
    id: "innovation-1",
    icon: star,
    title: "Advanced Engineering",
    content:
      "We employ cutting-edge engineering techniques to create innovative robotic solutions that address real-world challenges.",
  },
  {
    id: "innovation-2",
    icon: shield,
    title: "Smart Automation",
    content:
      "Our smart automation systems integrate seamlessly into various industries, enhancing productivity and efficiency.",
  },
  {
    id: "innovation-3",
    icon: send,
    title: "AI Integration",
    content:
      "By leveraging artificial intelligence, we develop intelligent systems capable of learning and adapting to new environments and tasks.",
  },
  {
    id: "innovation-4",
    icon: send,
    title: "Innovative Designs",
    content:
      "Our team constantly explores new design methodologies to create unique and efficient robotic systems.",
  },
];

export const heroes = [
  {
    id: "heroes-1",
    name: "Seyed Hossein Hosseini",
    title: "Founder & Tech Leader",
    img: people01,
    bio: "Passionate about autonomous systems and robotics. Leading our technical vision and driving innovation in AI-powered solutions.",
    expertise: [
      "AI/ML",
      "Robotics",
      "Software Engineering",
      "System Architecture",
    ],
    linkedinUrl: "https://www.linkedin.com/in/seyed-hossein-hosseini",
    instagramUrl: "https://www.instagram.com/hossein_hosseini",
    twitterUrl: "https://twitter.com/hossein_tech",
  },
  {
    id: "heroes-2",
    name: "Meisam Dehghan",
    title: "Founder & Mechanical Leader",
    img: people02,
    bio: "Expert in mechanical design and manufacturing. Specializing in autonomous vehicle systems and precision engineering.",
    expertise: [
      "Mechanical Design",
      "Manufacturing",
      "Vehicle Dynamics",
      "CAD/CAM",
    ],
    linkedinUrl: "https://www.linkedin.com/in/meisam-dehghan",
    instagramUrl: "https://www.instagram.com/meisam_mech",
    twitterUrl: "https://twitter.com/meisam_engineering",
  },
  {
    id: "heroes-3",
    name: "Aryan Emami",
    title: "Mechanical Engineer & Professional Racing",
    img: people03,
    bio: "Combining racing expertise with engineering precision. Developing high-performance autonomous systems for competitive environments.",
    expertise: [
      "Racing Engineering",
      "Performance Tuning",
      "Vehicle Dynamics",
      "Aerodynamics",
    ],
    linkedinUrl: "https://www.linkedin.com/in/aryan-emami",
    instagramUrl: "https://www.instagram.com/aryan_racing",
    twitterUrl: "https://twitter.com/aryan_racing_eng",
  },
  {
    id: "heroes-4",
    name: "Kiarash Nayeredin Zadeh",
    title: "Electrical Engineer",
    img: people04,
    bio: "Specializing in electrical systems and control engineering. Creating robust electrical architectures for autonomous platforms.",
    expertise: [
      "Electrical Systems",
      "Control Engineering",
      "PCB Design",
      "Embedded Systems",
    ],
    linkedinUrl: "https://www.linkedin.com/in/kiarash-nayeredin",
    instagramUrl: "https://www.instagram.com/kiarash_electrical",
    twitterUrl: "https://twitter.com/kiarash_ee",
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "User Active",
    value: "3800+",
  },
  {
    id: "stats-2",
    title: "Trusted by Company",
    value: "230+",
  },
  {
    id: "stats-3",
    title: "Transaction",
    value: "$230M+",
  },
];

export const footerLinks = [
  {
    title: "Useful Links",
    links: [
      {
        name: "Content",
        link: "/content/",
      },
      {
        name: "How it Works",
        link: "/how-it-works/",
      },
      {
        name: "Create",
        link: "/create/",
      },
      {
        name: "Explore",
        link: "/explore/",
      },
      {
        name: "Terms & Services",
        link: "/terms-and-services/",
      },
    ],
  },
  {
    title: "Community",
    links: [
      {
        name: "Help Center",
        link: "/help-center/",
      },
      {
        name: "Partners",
        link: "/partners/",
      },
      {
        name: "Suggestions",
        link: "/suggestions/",
      },
      {
        name: "Blog",
        link: "/blog/",
      },
      {
        name: "Newsletters",
        link: "/newsletters/",
      },
    ],
  },
  {
    title: "Partner",
    links: [
      // {
      //   name: "Our Sponsors",
      //   link: "/sponsors/",
      // },
      {
        name: "Become a Sponsor",
        link: "/sponsor/",
      },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
  {
    id: "social-media-3",
    icon: twitter,
    link: "https://www.twitter.com/",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/company/datam-dynamics/",
  },
];

export const clients = [
  {
    id: "client-1",
    logo: sponsor,
  },
  {
    id: "client-2",
    logo: sponsor,
  },
  {
    id: "client-3",
    logo: sponsor,
  },
  {
    id: "client-4",
    logo: sponsor,
  },
];
